export const SET_VISUAL_BUILDER_VALUES = "SET_VISUAL_BUILDER_VALUES";
export const RESET_VISUAL_BUILDER_VALUES = "RESET_VISUAL_BUILDER_VALUES";
